module.exports = __webpack_public_path__ + "static/media/NOTICE-INFORMATION.2a166d02.rtf";